module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "registrationContainer",
    staticClass: "container mt-3"
  }, [_c('img', {
    ref: "imgToExport",
    staticClass: "p-1",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "src": require("@/assets/images/grb.svg")
    }
  }), _vm._v(" "), (!_vm.registrationAllowed) ? _c('b-card', {
    staticClass: "p-3"
  }, [_c('b-row', {
    attrs: {
      "align-h": "center"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('register.registrationForbidden')))])])], 1) : _c('form', {
    ref: "registerForm",
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.validateBeforeSubmit($event)
      }
    }
  }, [_c('b-card', {
    staticClass: "mb-2 pt-0 mt-0"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('context-header', {
    attrs: {
      "title": _vm.$t('register.title'),
      "large": ""
    }
  })], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": ""
    }
  }, [_c('p', [_vm._v("\r\n                        " + _vm._s(_vm.$t('register.editRegistration')) + "\r\n                        "), _c('br'), _c('br'), _vm._v("\r\n                        " + _vm._s(_vm.$t('register.editRegistrationLine2')) + "\r\n                    ")])])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.editRegistrationModal",
      modifiers: {
        "editRegistrationModal": true
      }
    }],
    attrs: {
      "variant": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('register.registrationLoad')))])], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('register.legalEntityInfo')))]), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('register.budgetIdNumber')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.register.budgetNumber),
      expression: "register.budgetNumber"
    }],
    ref: "budgetIdNumber",
    staticClass: "form-control",
    class: {
      'error': _vm.$v.register.companyNumber.$error
    },
    attrs: {
      "name": "register.budgetIdNumber",
      "disabled": _vm.legalInformationEditable()
    },
    domProps: {
      "value": (_vm.register.budgetNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.register, "budgetNumber", $event.target.value)
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', [_c('p', [_c('small', [_vm._v(_vm._s(_vm.$t('register.budgetIdNumberFootnote')))])])])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('register.companyName')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.register.name),
      expression: "register.name"
    }],
    staticClass: "form-control",
    class: {
      'error': _vm.$v.register.name.$error
    },
    attrs: {
      "name": "register.name"
    },
    domProps: {
      "value": (_vm.register.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.register, "name", $event.target.value)
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "5"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('register.companyNumber')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.register.companyNumber),
      expression: "register.companyNumber"
    }],
    staticClass: "form-control",
    class: {
      'error': _vm.$v.register.companyNumber.$error
    },
    attrs: {
      "name": "register.companyNumber",
      "disabled": _vm.legalInformationEditable()
    },
    domProps: {
      "value": (_vm.register.companyNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.register, "companyNumber", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "5"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('register.taxIdNumber')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.register.taxIdNumber),
      expression: "register.taxIdNumber"
    }],
    staticClass: "form-control",
    class: {
      'error': _vm.$v.register.taxIdNumber.$error
    },
    attrs: {
      "name": "register.taxIdNumber",
      "disabled": _vm.legalInformationEditable()
    },
    domProps: {
      "value": (_vm.register.taxIdNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.register, "taxIdNumber", $event.target.value)
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('register.address')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.register.address),
      expression: "register.address"
    }],
    staticClass: "form-control",
    class: {
      'error': _vm.$v.register.address.$error
    },
    attrs: {
      "name": "register.address"
    },
    domProps: {
      "value": (_vm.register.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.register, "address", $event.target.value)
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "5"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('register.email')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.register.email),
      expression: "register.email"
    }],
    staticClass: "form-control",
    class: {
      'error': _vm.$v.register.email.$error
    },
    attrs: {
      "type": "email",
      "name": "register.email"
    },
    domProps: {
      "value": (_vm.register.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.register, "email", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('general.phone')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.register.phoneNumber),
      expression: "register.phoneNumber"
    }],
    staticClass: "form-control",
    class: {
      'error': _vm.$v.register.phoneNumber.$error
    },
    attrs: {
      "name": "register.phoneNumber"
    },
    domProps: {
      "value": (_vm.register.phoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.register, "phoneNumber", $event.target.value)
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('register.adminInfo')))]), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('register.name')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.register.adminName),
      expression: "register.adminName"
    }],
    staticClass: "form-control",
    class: {
      'error': _vm.$v.register.adminName.$error
    },
    attrs: {
      "name": "register.adminName"
    },
    domProps: {
      "value": (_vm.register.adminName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.register, "adminName", $event.target.value)
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('register.identityNumber')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.register.adminIdentityNumber),
      expression: "register.adminIdentityNumber"
    }],
    staticClass: "form-control",
    class: {
      'error': _vm.$v.register.adminIdentityNumber.$error
    },
    attrs: {
      "name": "register.adminIdentityNumber"
    },
    domProps: {
      "value": (_vm.register.adminIdentityNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.register, "adminIdentityNumber", $event.target.value)
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "5"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('general.email')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.register.adminEmail),
      expression: "register.adminEmail"
    }],
    staticClass: "form-control",
    class: {
      'error': _vm.$v.register.adminEmail.$error
    },
    attrs: {
      "type": "email",
      "name": "register.adminEmail"
    },
    domProps: {
      "value": (_vm.register.adminEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.register, "adminEmail", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('general.phone')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.register.adminPhoneNumber),
      expression: "register.adminPhoneNumber"
    }],
    staticClass: "form-control",
    class: {
      'error': _vm.$v.register.adminPhoneNumber.$error
    },
    attrs: {
      "name": "register.adminPhoneNumber"
    },
    domProps: {
      "value": (_vm.register.adminPhoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.register, "adminPhoneNumber", $event.target.value)
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('register.treasuryBranchInfo')))]), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('register.treasuryBranch')
    }
  }, [_c('autocomplete', {
    ref: "treasuryBranchAutocomplete",
    attrs: {
      "inputClass": _vm.autocompleteErrorClass(),
      "url": _vm.autoCompleteUrl_branches,
      "criteria": "branchCode",
      "description": "name",
      "name": "register.treasuryBranch"
    },
    model: {
      value: (_vm.register.treasuryBranch),
      callback: function($$v) {
        _vm.$set(_vm.register, "treasuryBranch", $$v)
      },
      expression: "register.treasuryBranch"
    }
  })], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('p', {
    staticStyle: {
      "padding-top": "1em",
      "color": "#bbb5b5"
    }
  }, [_vm._v(_vm._s(_vm.$t('register.treasuryBranchNote')))])])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-link', {
    staticStyle: {
      "position": "absolute",
      "margin-top": "-1em"
    },
    attrs: {
      "href": _vm.ouLink
    }
  }, [_vm._v(_vm._s(_vm.$t('register.ouList')))])], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-row', {
    staticClass: "mt-3 text-right",
    attrs: {
      "align-h": "end"
    }
  }, [_c('b-col', {
    staticClass: "mr-3",
    attrs: {
      "cols": "*"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "primary",
      "disabled": _vm.load,
      "type": "submit"
    }
  }, [_vm._v("\r\n                            " + _vm._s(_vm.$t('register.submit')) + "\r\n                            "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mr-3",
    attrs: {
      "cols": "*"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success",
      "disabled": _vm.load || !_vm.registrationToExport,
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.printRegistration()
      }
    }
  }, [_vm._v("\r\n                            " + _vm._s(_vm.$t('register.printRequestForm')) + "\r\n                            "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "text-right",
    attrs: {
      "align-h": "end",
      "align-v": "end"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.$t('register.infoText')))])])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('b-modal', {
    ref: "registerConfirmationModal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "header-bg-variant": "success",
      "header-text-variant": "light",
      "title": _vm.$t('forms.notification'),
      "centered": ""
    }
  }, [_c('p', {
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v(_vm._s(_vm.$t('register.registrationSuccess')))]), _vm._v(" "), (_vm.registrationConfirmation) ? _c('p', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_vm._l((_vm.registrationConfirmation.split('\n')), function(line) {
    return [_vm._v(_vm._s(line)), _c('br')]
  })], 2) : _vm._e(), _vm._v(" "), _c('b-card', {
    attrs: {
      "bg-variant": "danger",
      "text-variant": "white"
    }
  }, [_c('p', [_vm._v("\r\n                    " + _vm._s(_vm.$t('register.registrationSuccessText')) + "\r\n                ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('b-btn', {
    staticClass: "float-right m-1",
    attrs: {
      "variant": "success",
      "disabled": !_vm.registrationToExport
    },
    on: {
      "click": function($event) {
        return _vm.printRegistration()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('register.printRequestForm')))])], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "editRegistrationModalRef",
    attrs: {
      "id": "editRegistrationModal",
      "title": _vm.$t('register.editRegistrationLoad'),
      "centered": ""
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('register.editRegistrationToken')
    },
    model: {
      value: (_vm.registrationToken),
      callback: function($$v) {
        _vm.registrationToken = $$v
      },
      expression: "registrationToken"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('b-btn', {
    staticClass: "float-right m-1",
    attrs: {
      "variant": "success",
      "disabled": _vm.load || !_vm.registrationToken
    },
    on: {
      "click": function($event) {
        return _vm.sendRegistrationToken()
      }
    }
  }, [_vm._v("\r\n                    " + _vm._s(_vm.$t('forms.load')) + "\r\n                    "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5009dc17", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5009dc17","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","b-img":"src"}}!./src/components/register/register.html
// module id = 783
// module chunks = 1